import instance from '@apis/instance';
import {
  PrepaidCardChargeRequest,
  PrepaidCardOrderRequest,
  PrepaidCardOrderResponse,
  PrepaidCardPaymentRequest,
  PrepaidCardPaymentResponse,
} from '@models/prepaidCard';
import axios from 'axios';

class PrepaidCardSaleApi {
  static registerOrder(request: PrepaidCardOrderRequest): Promise<PrepaidCardOrderResponse> {
    return instance.post('/prepaid-card/purchase', request);
  }

  static async registerCharge(id: string, request: PrepaidCardChargeRequest): Promise<PrepaidCardOrderResponse> {
    return instance.post(`/prepaid-card/${id}/charge`, request);
  }

  static paymentOrder(request: PrepaidCardPaymentRequest): Promise<PrepaidCardPaymentResponse> {
    // return instance.post('/prepaid-card/payment', request);
    return new Promise((resolve) => {
      resolve({ authPageUrl: 'test' });
    });
  }
}

export default PrepaidCardSaleApi;
